{
  "030cd98636706bfc": "Error al eliminar el nivel",
  "041a6694b3bb1286": "Los turnos creados dentro de las horas umbral del tiempo de inicio tendrán el diferencial de cargo listado agregado al Cargo Base del Lugar de Trabajo.",
  "0e48ffeec1f32305": "Los turnos creados dentro del umbral del tiempo de inicio tendrán el diferencial de cargo agregado al Cargo Base del Lugar de Trabajo.",
  "1428ca351bbee731": "Se aplica la tarifa de urgencia heredada hasta que se agregue un nivel de Programación de Tarifas de Urgencia",
  "19766ed6ccb2f4a3": "Cancelar",
  "1d286cfa8b050852": "No hay niveles configurados. Agrega uno para empezar a aplicar diferenciales de cargos por tiempo de anticipación.",
  "29615b6c84d469a4": "Entre {{minimumHours}} y {{maximumHours}} horas.",
  "3f5ac997aacafd3b": "Diferencial de cargo sobre el cargo base",
  "45ef29b75657779f": "Error al agregar el nivel",
  "4759498ac2a719c6": "Crear",
  "63cc42e756e0dfad": "Error al cargar los niveles. Intenta refrescar.",
  "6ca7478fe7384fbe": "Entre {{minimumPercent}}% y {{maximumPercent}}%.",
  "7d2f6a7754d58b7b": "+ Agregar nivel",
  "89c3016595a8ae9d": "p. ej. 12",
  "8ba512b5611a0b76": "Programa de Tarifa de Urgencia de Turnos",
  "8c00bdc065aac77d": "Nivel agregado",
  "98167f67ad7f2ad1": "Agregar nivel",
  "a9ffa37c57370176": "Umbral (horas)",
  "da7d002ac58c3013": "Nivel eliminado",
  "e2d0a54968ead24e": "Eliminar",
  "e6d53f2e5db0aed7": "p. ej. 5"
}
